module.exports = __webpack_public_path__ + "static/media/flipcards.4b344031.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/flipcards.jpg
// module id = 27
// module chunks = 0